import { render, staticRenderFns } from "./field-group-form.vue?vue&type=template&id=274324f7&scoped=true&"
import script from "./field-group-form.vue?vue&type=script&lang=js&"
export * from "./field-group-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274324f7",
  null
  
)

export default component.exports